import { useRef } from "react";
import { FaPlay, FaPause, FaWhatsapp, FaLink } from "react-icons/fa";
import podcastAudio from "../assets/podcast.mp3";

export default function ZaffloPodcast() {
  const audioRef = useRef(null);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (audioRef.current.paused) audioRef.current.play();
    else audioRef.current.pause();
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white text-gray-900">

      {/* HERO */}
      <div className="max-w-4xl mx-auto px-6 pt-16 pb-10 text-center">
        
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
          Zafflo Podcast Discussion
        </h1>

        <p className="mt-4 text-gray-600 text-lg">
          A short conversation about how Zafflo is transforming
          restaurant ordering, customer engagement and growth.
        </p>

      </div>

      {/* PLAYER CARD */}
      <div className="max-w-3xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8">

          <div className="flex flex-col items-center">

            {/* Cover Circle */}
            <div className="w-32 h-32 rounded-full bg-gradient-to-tr from-amber-400 to-orange-500 flex items-center justify-center shadow-lg mb-6">
              <span className="text-white text-3xl font-bold">Z</span>
            </div>

            <h2 className="text-2xl font-semibold text-center">
              How Zafflo Helps Businesses Grow Faster
            </h2>

            <p className="text-gray-500 mt-2 text-center">
              Duration: 5 minutes
            </p>

            {/* AUDIO */}
            <audio
              ref={audioRef}
              src={podcastAudio}   // <-- replace with your file path / Firebase URL
              className="hidden"
            />

            {/* PLAY BUTTON */}
            <button
              onClick={togglePlay}
              className="mt-6 flex items-center gap-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition"
            >
              <FaPlay />
              Play Podcast
            </button>

            {/* Native Controls fallback */}
            <audio
              controls
              src={podcastAudio}   // <-- replace with your file path
              className="w-full mt-6"
            />

          </div>
        </div>
      </div>

      {/* DESCRIPTION */}
      <div className="max-w-3xl mx-auto px-6 mt-12">

        <h3 className="text-xl font-semibold mb-3">
          About this podcast
        </h3>

        <p className="text-gray-600 leading-relaxed">
          This short podcast covers how Zafflo enables restaurants, cafés,
          hotels and service businesses to digitize their menu, receive orders
          directly on WhatsApp, and improve customer retention without
          expensive apps or hardware.
        </p>

        <p className="text-gray-600 mt-4">
          Perfect for business owners exploring modern ordering systems and
          looking to increase repeat customers and operational efficiency.
        </p>

      </div>

      {/* CTA */}
      <div className="max-w-3xl mx-auto px-6 mt-12 pb-20 text-center">

        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-3xl p-10 text-white shadow-xl">

          <h3 className="text-2xl font-semibold">
            Want to see Zafflo in action?
          </h3>

          <p className="mt-2 opacity-90">
            Book a live demo and see how it works for your business.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-6">

            <a
              href="https://zafflo.com/menu/zafflo-solutions"
              className="bg-white text-orange-600 px-6 py-3 rounded-xl font-semibold hover:bg-gray-100 transition flex items-center gap-2"
            >
              <FaLink /> Book Demo
            </a>

            <a
              href="https://wa.me/918097588099"
              className="bg-green-500 px-6 py-3 rounded-xl font-semibold hover:bg-green-600 transition flex items-center gap-2"
            >
              <FaWhatsapp /> Chat on WhatsApp
            </a>

          </div>

        </div>

      </div>

    </div>
  );
}